export const sand = {
  1: { value: { base: '{colors.sand.light.1}', _dark: '{colors.sand.dark.1}' } },
  2: { value: { base: '{colors.sand.light.2}', _dark: '{colors.sand.dark.2}' } },
  3: { value: { base: '{colors.sand.light.3}', _dark: '{colors.sand.dark.3}' } },
  4: { value: { base: '{colors.sand.light.4}', _dark: '{colors.sand.dark.4}' } },
  5: { value: { base: '{colors.sand.light.5}', _dark: '{colors.sand.dark.5}' } },
  6: { value: { base: '{colors.sand.light.6}', _dark: '{colors.sand.dark.6}' } },
  7: { value: { base: '{colors.sand.light.7}', _dark: '{colors.sand.dark.7}' } },
  8: { value: { base: '{colors.sand.light.8}', _dark: '{colors.sand.dark.8}' } },
  9: { value: { base: '{colors.sand.light.9}', _dark: '{colors.sand.dark.9}' } },
  10: { value: { base: '{colors.sand.light.10}', _dark: '{colors.sand.dark.10}' } },
  11: { value: { base: '{colors.sand.light.11}', _dark: '{colors.sand.dark.11}' } },
  12: { value: { base: '{colors.sand.light.12}', _dark: '{colors.sand.dark.12}' } },
  a1: { value: { base: '{colors.sand.light.a1}', _dark: '{colors.sand.dark.a1}' } },
  a2: { value: { base: '{colors.sand.light.a2}', _dark: '{colors.sand.dark.a2}' } },
  a3: { value: { base: '{colors.sand.light.a3}', _dark: '{colors.sand.dark.a3}' } },
  a4: { value: { base: '{colors.sand.light.a4}', _dark: '{colors.sand.dark.a4}' } },
  a5: { value: { base: '{colors.sand.light.a5}', _dark: '{colors.sand.dark.a5}' } },
  a6: { value: { base: '{colors.sand.light.a6}', _dark: '{colors.sand.dark.a6}' } },
  a7: { value: { base: '{colors.sand.light.a7}', _dark: '{colors.sand.dark.a7}' } },
  a8: { value: { base: '{colors.sand.light.a8}', _dark: '{colors.sand.dark.a8}' } },
  a9: { value: { base: '{colors.sand.light.a9}', _dark: '{colors.sand.dark.a9}' } },
  a10: { value: { base: '{colors.sand.light.a10}', _dark: '{colors.sand.dark.a10}' } },
  a11: { value: { base: '{colors.sand.light.a11}', _dark: '{colors.sand.dark.a11}' } },
  a12: { value: { base: '{colors.sand.light.a12}', _dark: '{colors.sand.dark.a12}' } },
}
